<template>
  <div>
    <h1>
      {{ user.id != null ? $t("settings.users.userEdit") : $t("settings.users.userNew") }}
    </h1>

    <div class="mt-3 elevation-12 grey lighten-4">
      <user-settings-menu />
      <v-card>
        <v-card-text>
          <v-form lazy-validation ref="form" v-model="formValid">
            <v-text-field :label="$t('settings.users.delegationData.fields.integrationIdentifier.name')" v-model="user.integration_identifier" />
            <v-autocomplete :items="availableSuperiors" :label="$t('settings.users.delegationData.fields.superiorUser.name')" v-model="user.superior_user_id" />
            <v-autocomplete
              :items="availableOrganisationStructures"
              :label="$t('settings.users.delegationData.fields.organizationStructure.name')"
              v-model="user.organization_structure_id"
            />
            <v-autocomplete
              :items="availablePrivateVehicles"
              :label="$t('settings.users.delegationData.fields.privateVehicle.name')"
              v-model="user.vehicle_private_id"
            />
            <v-autocomplete
              :items="availableDefaultVehicles"
              :label="$t('settings.users.delegationData.fields.defaultVehicle.name')"
              v-model="user.vehicle_default_id"
            />
            <v-text-field :label="$t('settings.users.delegationData.fields.bankName.name')" v-model="user.bank_name" />
            <v-text-field :label="$t('settings.users.delegationData.fields.bankAccount.name')" v-model="user.bank_account_number" />
            <location-ajax-select :label="$t('global.homeLocation')" :placeholder="user.home_address_name" :select-model.sync="user.home_address_id" />
            <location-ajax-select :label="$t('global.workLocation')" :placeholder="user.work_address_name" :select-model.sync="user.work_address_id" />
            <v-autocomplete
              :clearable="true"
              :items="availableDelegationGroups"
              :label="$t('settings.users.delegationData.fields.delegationRateGroup.name')"
              v-model="user.group_id"
            />
            <v-select :items="languageChooser" :label="$t('settings.users.delegationData.fields.language.name')" v-model="user.language" />
          </v-form>
        </v-card-text>
      </v-card>

      <v-card>
        <v-card-actions>
          <v-spacer />
          <v-btn @click.native="cancel()" color="blue darken-1" text>{{ $t("global.cancel") }}</v-btn>
          <v-btn :disabled="!formValid || $store.getters['Ajax/loading']" @click="save()" color="blue darken-1" text>{{ $t("global.save") }} </v-btn>
        </v-card-actions>
      </v-card>
    </div>
  </div>
</template>

<script>
import LocationAjaxSelect from "../../../../components/CustomInputComponents/LocationAjaxSelect.vue";
import UserSettingsMenu from "../../../../components/Settings/Users/UserSettingsMenu";
import vehicleTypes from "../../../../staticData/VehicleTypes";

export default {
  name: "SettingsUserEditDelegationView",
  components: { UserSettingsMenu, LocationAjaxSelect },
  data: () => ({
    user: {
      id: null,
      integration_identifier: null,
      superior_user_id: null,
      organization_structure_id: null,
      vehicle_private_id: null,
      vehicle_default_id: null,
      bank_name: null,
      bank_account_number: null,
      home_address_id: null,
      home_address_name: null,
      work_address_name: null,
      work_address_id: null,
      group_id: null,
      language: null,
      cost_centre: null
    },
    nonChangeUser: null,
    allSuperiorUsers: [],
    allOrganisationStructures: [],
    allPrivateVehicles: [],
    formValid: true,
    allVehicles: [],
    allDelegationGroups: [],
    search: null
  }),
  created() {
    this.axios
      .get("settings/user/get-delegation-data", {
        params: { userId: this.$route.params.id }
      })
      .then(resp => {
        let user = resp.data;
        this.user = user;
        this.nonChangeUser = JSON.parse(JSON.stringify(user));
      });
    this.axios.get("settings/user/available-superior-users").then(resp => {
      this.allSuperiorUsers = resp.data;
    });
    this.axios.get("settings/user/available-organisation-structures").then(resp => {
      this.allOrganisationStructures = resp.data;
    });
    this.axios.get("settings/user/available-private-vehicles").then(resp => {
      this.allPrivateVehicles = resp.data;
    });
    this.axios.get("settings/user/available-default-vehicles").then(resp => {
      this.allVehicles = resp.data;
    });
    this.axios.get("settings/user/available-delegation-groups").then(resp => {
      this.allDelegationGroups = resp.data;
    });
  },
  computed: {
    languageChooser() {
      let result = [];
      result.push({
        text: this.$t("settings.users.fields.language.polish"),
        value: "pl-PL"
      });
      result.push({
        text: this.$t("settings.users.fields.language.english"),
        value: "en-US"
      });
      return result;
    },
    vehicleTypes: vehicleTypes,
    availableSuperiors() {
      const array = [];
      for (let superiorUser of this.allSuperiorUsers) {
        if (superiorUser.id !== this.user.id) {
          array.push({
            value: superiorUser.id,
            text: superiorUser.name + " " + superiorUser.surname + " (" + superiorUser.login + ")"
          });
        }
      }
      return array;
    },
    availableOrganisationStructures() {
      const array = [];
      for (let organisation of this.allOrganisationStructures) {
        array.push({
          value: organisation.id,
          text: organisation.name + " " + organisation.description
        });
      }
      return array;
    },
    availablePrivateVehicles() {
      const array = [];
      for (let vehicle of this.allPrivateVehicles) {
        array.push({
          value: vehicle.id,
          text:
            this.vehicleTypes.filter(vehicleType => vehicleType.id === vehicle.type).pop().name +
            " " +
            vehicle.model +
            " " +
            vehicle.engine_capacity +
            " cm3 (" +
            vehicle.plates +
            ")"
        });
      }
      return array;
    },
    availableDefaultVehicles() {
      const array = [];
      for (let vehicle of this.allVehicles) {
        array.push({
          value: vehicle.id,
          text:
            this.vehicleTypes.filter(vehicleType => vehicleType.id === vehicle.type).pop().name +
            " " +
            vehicle.model +
            " " +
            vehicle.engine_capacity +
            " cm3 (" +
            vehicle.plates +
            ")"
        });
      }
      return array;
    },
    availableDelegationGroups() {
      const array = [];
      for (let delegationGroup of this.allDelegationGroups) {
        array.push({
          value: delegationGroup.id,
          text: delegationGroup.name + " " + delegationGroup.description
        });
      }
      return array;
    }
  },
  methods: {
    formChanged() {
      for (let propertyName in this.user) {
        if (this.nonChangeUser[propertyName] !== this.user[propertyName]) {
          return true;
        }
      }
      return false;
    },
    cancel() {
      this.$router.push("/settings/users");
    },
    save() {
      this.axios.post("settings/user/save-delegation-data", this.user).then(() => {
        this.$store.dispatch("snackbarPush", {
          text: this.$t("global.saved"),
          position: "down"
        });
        this.nonChangeUser = this.user;
      });
    }
  },
  beforeRouteLeave(from, to, next) {
    if (this.formChanged()) {
      let result = this.$store.dispatch("confirmDialog", {
        content: this.$t("global.saveBeforeExit.content"),
        title: this.$t("global.saveBeforeExit.title"),
        customButtons: [
          { text: this.$t("global.cancel"), value: "cancel" },
          { text: this.$t("global.no"), value: "no" },
          { text: this.$t("global.yes"), color: "primary", value: "yes" }
        ]
      });
      result.then(chosen => {
        if (chosen === "cancel") {
          next(false);
        } else if (chosen === "no") {
          next();
        } else if (chosen === "yes") {
          this.axios.post("settings/user/save-delegation-data", this.user).then(() => {
            this.$store.dispatch("snackbarPush", {
              text: this.$t("global.saved"),
              position: "down"
            });
            next();
          });
        }
      });
    } else {
      next();
    }
  }
};
</script>

<style scoped></style>
